import { LACKS_FIELD_ACCESS } from './problems';
export const getProblemTooltipUse = problem => problem === LACKS_FIELD_ACCESS ? 'longform' : 'default';